import React, { useEffect } from 'react'

import { isNumber } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { InvoiceForm } from './InvoiceForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

export const InvoiceEditPage = () => {
    const {t} = useTranslation()
    const params = useParams()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (isNaN(parseInt(params.invoiceId as string)) || parseInt(params.invoiceId as string) <= 0) {
            navigate('/app/invoices')
        }
    }, [params.invoiceId])

    return (
        <AppLayout>
            <AppTitle append={
                <Link to={'/app/invoices'}>
                    <button className="btn amani-primary">{t('back')}</button>
                </Link>}>{searchParams.get('invoiceNo') ? t('invoice_no', {no: searchParams.get('invoiceNo')}) : t('edit_invoice')}</AppTitle>

            <InvoiceForm id={parseInt(params.invoiceId as string)}/>
        </AppLayout>
    )
}